<script setup lang="ts">
import { useStore } from "vuex";
import {computed} from "vue";
import ButtonGroup from "@/components/UI/ButtonGroup.vue";
import ButtonPrimitive from "@/components/UI/ButtonPrimitive.vue";

const store = useStore();
const selectedMenuItem = computed(() => store.getters.selectedMenuItem);
const shapeSelectorButtons = computed(() => store.getters.shapeSelectorButtons);
const activeItemIndex = computed(() => {
	const index = shapeSelectorButtons.value.findIndex( ( item: {
		active: boolean;
	} )=> item.active === true);

	return index === -1 ? 0 : index;
});

function onClick(type: string, reset = false): void {
	updateShape(type === "shapes" ? "" : type);
	updateCurrentMenuItem(type);

	if (reset) {
		resetUpload();
	}
}

function updateShape(shape: string) {
	store.dispatch("updateShape", shape);
	store.dispatch("resetDrillHoles");
	store.commit("updatePresetShape", "");
}

function updateCurrentMenuItem(selectedMenuItem: string) {
	store.commit("updateMenuItem", selectedMenuItem);
	addMenuItemToDataLayer(selectedMenuItem);
}

function addMenuItemToDataLayer(menuItem: string) {
	if (!menuItem || 0 === menuItem.length) return;

	window?.dataLayer?.push({
		event: "measurements_selector",
		eventCategory: "Shapes & Sizes:" + document.title,
		eventAction: "Step 1. Shape Type",
		eventLabel: menuItem,
	});
}

function resetUpload() {
	store.commit("updateDxfDefinition", {
		svgPath: "",
	});

	// Reset the dxf export state, becasuse of switching between dxf and text
	store.commit('setUploadedContent', {result: '', filename: ''} );
}

</script>

<template>
	<button-group :buttons-per-row="4" :total-buttons="shapeSelectorButtons.length" :selected-item="activeItemIndex">
		<button-primitive
			v-for="(item, index) in shapeSelectorButtons"
			:key="index"
			:on-click="() => onClick(item.handler, item.reset)"
			:icon="item.icon"
			:text="item.text"
			:index="index"
			:is-active="item.selection === selectedMenuItem"
		/>
	</button-group>
</template>

<style scoped lang="scss">
.button {
	color: $brand-blue-dark;
	padding-block: 7px;

	@include hover-focus-style {
		border-color: transparent;
	}

	&:focus-visible {
		outline-color: $outline-color;
	}

	.button__icon {
		width: 44px;
		height: 44px;
	}
}
</style>
